/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Space_Members_Manage_Extra_Seats_Per_SeatInputs */

const en_space_members_manage_extra_seats_per_seat = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Per_SeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per seat`)
};

const de_space_members_manage_extra_seats_per_seat = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Per_SeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Sitz`)
};

const es_space_members_manage_extra_seats_per_seat = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Per_SeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por plaza`)
};

const fr_space_members_manage_extra_seats_per_seat = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Per_SeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par place`)
};

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Per_SeatInputs) => LocalizedString} */
const it_space_members_manage_extra_seats_per_seat = en_space_members_manage_extra_seats_per_seat;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Per_SeatInputs) => LocalizedString} */
const pt_br2_space_members_manage_extra_seats_per_seat = en_space_members_manage_extra_seats_per_seat;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Per_SeatInputs) => LocalizedString} */
const pl_space_members_manage_extra_seats_per_seat = en_space_members_manage_extra_seats_per_seat;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Per_SeatInputs) => LocalizedString} */
const hu_space_members_manage_extra_seats_per_seat = en_space_members_manage_extra_seats_per_seat;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Per_SeatInputs) => LocalizedString} */
const ro_space_members_manage_extra_seats_per_seat = en_space_members_manage_extra_seats_per_seat;

/**
* | output |
* | --- |
* | "per seat" |
*
* @param {Space_Members_Manage_Extra_Seats_Per_SeatInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const space_members_manage_extra_seats_per_seat = /** @type {((inputs?: Space_Members_Manage_Extra_Seats_Per_SeatInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Space_Members_Manage_Extra_Seats_Per_SeatInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_space_members_manage_extra_seats_per_seat(inputs)
	if (locale === "de") return de_space_members_manage_extra_seats_per_seat(inputs)
	if (locale === "es") return es_space_members_manage_extra_seats_per_seat(inputs)
	if (locale === "fr") return fr_space_members_manage_extra_seats_per_seat(inputs)
	if (locale === "it") return it_space_members_manage_extra_seats_per_seat(inputs)
	if (locale === "pt-BR") return pt_br2_space_members_manage_extra_seats_per_seat(inputs)
	if (locale === "pl") return pl_space_members_manage_extra_seats_per_seat(inputs)
	if (locale === "hu") return hu_space_members_manage_extra_seats_per_seat(inputs)
	return ro_space_members_manage_extra_seats_per_seat(inputs)
});
export { space_members_manage_extra_seats_per_seat as "space.members.manage_extra_seats.per_seat" }